import AccountsManagerContainer from './AccountsManagerContainer';

export default AccountsManagerContainer;
